module.exports = __webpack_public_path__ + "static/img/car.083120fb.png";